<div class="p-6 md:p-8 flex flex-col items-center text-center space-y-6">
  <div class="space-y-1">
    <p class="text-xl md:text-2xl font-bold text-gray-700">Request a Demo</p>
    <p class="text-sm md:text-base text-gray-500">
      First, tell us who you are.
    </p>
  </div>
  <div class="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
    <a
      [href]="getStartedUrl()"
      target="_blank"
      mat-dialog-close
      class="button primary transition-colors whitespace-nowrap justify-center gap-x-2"
    >
      <mat-icon class="!text-lg !w-auto !h-auto">business</mat-icon>
      I'm a Company
    </a>
    <a
      routerLink="/auto-apply"
      mat-dialog-close
      class="button transition-colors whitespace-nowrap justify-center gap-x-2 text-primary border border-primary hover:bg-primary-extra-light"
    >
      <mat-icon class="!text-lg !w-auto !h-auto">person</mat-icon>
      I'm a Job Seeker
    </a>
  </div>
</div>
